<template>
  <el-container v-loading="isShowLoading">
    <el-main>
      <el-row>
        <el-form :model="filterData" :inline="true">
          <el-form-item>
            <el-input v-model="filterData.dsrwMc" placeholder="请输入任务名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filterData.ssyy" placeholder="请输入所属应用"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="filterData.qtzt" placeholder="--启停状态选择--">
              <el-option label="--启停状态选择--" value></el-option>
              <el-option label="启动" value="1"></el-option>
              <el-option label="停止" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" icon="el-icon-search" @click="onFilter">查询</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="onAdd">新增</el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            @click="onEdit"
            v-bind:disabled="enableBtn.update"
          >修改</el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-delete"
            @click="onDel"
            v-bind:disabled="enableBtn.del"
          >禁用</el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-video-play"
            @click="onWork('1')"
            v-bind:disabled="enableBtn.on"
          >启动</el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-video-pause"
            @click="onWork('0')"
            v-bind:disabled="enableBtn.stop"
          >停止</el-button>
        </el-col>
      </el-row>

      <el-table ref="singleTable" :data="recordData" highlight-current-row style="width: 100%" :height="tableHeight"
        :header-cell-style="{background:'#f5f7fa', color: 'black'}" border :stripe="stripeVisible">
        <el-table-column property="dsrwLsh" label="选择" align="center" width="70">
          <template slot-scope="scope">
            <el-radio
              :label="scope.$index+1"
              v-model="radio"
              @change.native="getCurrentRow(scope.row)"
            ></el-radio>
          </template>
        </el-table-column>
        <el-table-column property="ssyy" label="所属应用" width="120"></el-table-column>
        <el-table-column property="dsrwMc" label="任务名称" width="210">
            <template slot-scope="scope">
              <div
                class="dt"
                @click="columnDeal(scope.row.dsrwMc)"
              >
                {{scope.row.dsrwMc}}
              </div>
            </template>
        </el-table-column>
        <el-table-column property="dssjBds" label="时间表达式" width="110"></el-table-column>
        <el-table-column property="rwzxl" label="任务执行类" width="220">
            <template slot-scope="scope">
              <div
                class="dt"
                @click="columnDeal(scope.row.rwzxl)"
              >
                {{scope.row.rwzxl}}
              </div>
            </template>
        </el-table-column>
        <el-table-column property="rwzxff" label="任务执行方法" width="150">
            <template slot-scope="scope">
              <div
                class="dt"
                @click="columnDeal(scope.row.rwzxff)"
              >
                {{scope.row.rwzxff}}
              </div>
            </template>
        </el-table-column>
        <el-table-column property="bfzxzt" label="并行执行" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.bfzxzt == '1'">
              <i class="el-icon-success"></i>开启
            </div>
            <div v-else-if="scope.row.bfzxzt == '0'">
              <i class="el-icon-remove"></i>不开启
            </div>
          </template>
        </el-table-column>
        <el-table-column property="qtzt" label="启停状态" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.qtzt == '1'">
              <i class="el-icon-success"></i>启动
            </div>
            <div v-else-if="scope.row.qtzt == '0'">
              <i class="el-icon-remove"></i>停止
            </div>
          </template>
        </el-table-column>
        <el-table-column property="yxbz" label="启用标识" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.yxbz == 'Y'">
              <i class="el-icon-success"></i>启用
            </div>
            <div v-else-if="scope.row.yxbz == 'N'">
              <i class="el-icon-remove"></i>禁用
            </div>
          </template>
        </el-table-column>
        <el-table-column property="bz" label="备注" width="180">
            <template slot-scope="scope">
              <div
                class="dt"
                @click="columnDeal(scope.row.bz)"
              >
                {{scope.row.bz}}
              </div>
            </template>
        </el-table-column>
        <el-table-column property="xh" label="序号" width="60"></el-table-column>
        <el-table-column property="lrr" label="录入人" width="120"></el-table-column>
        <el-table-column property="lrsj" label="录入时间" width="155"></el-table-column>
        <el-table-column property="xgr" label="修改人" width="100"></el-table-column>
        <el-table-column property="xgsj" label="修改时间" width="155"></el-table-column>
      </el-table>
      <el-row style="margin: 18px 8px">
        <el-col :span="24">
          <pagination
            v-show="pagination.total/pagination.pageSize>1"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
            :page.sync="pagination.page"
            :limit.sync="pagination.pageSize"
            @pagination="onFilter"
          />
        </el-col>
      </el-row>

      <div style="height: 60px"></div>
      <el-drawer
        :visible.sync="layout.edit"
        :show-close="false"
        :wrapperClosable="false"
        :withHeader="false"
        :size="pageWidth + 'px'"
        direction="rtl"
        custom-class="demo-drawer"
        style="top: 67px"
      >
        <div class="demo-drawer-content">
          <Entity
            v-if="layout.edit"
            @back="back"
            @reload="init"
            v-bind:entity="entityData"
            ref="itemPanel"
          ></Entity>
        </div>
      </el-drawer>
    </el-main>
  </el-container>
</template>

<script>
import Entity from "./Entity.vue";

let _kits, _table;
export default {
  components: {
    Entity
  },
  data() {
    return {
      isShowLoading: true,
      isShowItem: false,
      pageWidth: 600,
      radio: "",
      templateSelection: {},
      //页面布局相关
      layout: {
        loading: true,
        width: 600,
        wd: "80%",
        edit: false
      },
      //数据绑定相关
      filterData: {}, //过滤信息
      recordData: [], //展示信息
      pagination: {
        total: 0,
        page: 1,
        pageSize: 10
      }, //分页信息
      entityData: {}, //具体某一项信息
      enableBtn: {
        update: true,
        del: true,
        on: true,
        stop: true
      }
    };
  },
  methods: {
    onAdd() {
      this.layout.edit = true;
      this.entityData = {
        create: true
      };
    },
    onEdit() {
      this.entityData = {
        dsrwLsh: this.templateSelection.dsrwLsh,
        create: false
      };
      this.layout.edit = true;
    },
    onWork(qtzt) {
      this.layout.loading = true;
      _kits.message("正在启动定时任务");
      _kits.api.update(
        "ENABLEDSREPZ",
        {
          dsrwLsh: this.templateSelection.dsrwLsh,
          qtzt: qtzt
        },
        () => {
          this.radio = "";
          this.init();
        this.enableBtn.update = true;
        this.enableBtn.del = true;
        this.enableBtn.on = true;
        this.enableBtn.stop = true;
        }
      );
    },
    onDel() {
      var qtzt = this.templateSelection.qtzt;
      console.log("templateSelection", this.templateSelection);
      if (qtzt != "0") {
        _kits.message("只有停止状态的任务才允许禁用");
        return;
      }
      _kits.confirm({
        text: "确定禁用此接口?",
        yes: () => {
          this.layout.loading = true;
          _kits.message("正在禁用接口");
          _kits.api.update(
            "DELETEDSRWPZ",
            {
              dsrwLsh: this.templateSelection.dsrwLsh
            },
            () => {
              this.radio = "";
              this.init();
        this.enableBtn.update = true;
        this.enableBtn.del = true;
        this.enableBtn.on = true;
        this.enableBtn.stop = true;
            }
          );
        }
      });
    },
    onFilter() {
      console.log(_kits.data("filterData"));
      this.layout.loading = true;
      this.radio = "";
      this.enableBtn.update = true;
      this.enableBtn.del = true;
      this.enableBtn.on = true;
      this.enableBtn.stop = true;
      _table.load();
    },
    init() {
      _table.load();
    },
    back() {
      //console.log("back")
      this.layout.edit = false;
      this.radio = "";
      this.enableBtn.update = true;
      this.enableBtn.del = true;
      this.enableBtn.on = true;
      this.enableBtn.stop = true;
    },
    getCurrentRow(row) {
      //获取选中数据
      this.templateSelection = row;
      console.log("row",row);
      if (row.yxbz == "Y") {
        this.enableBtn.del = false;

        if (row.qtzt == "0") {
          this.enableBtn.on = false;
          this.enableBtn.stop = true;
          this.enableBtn.update = false;
        } else if (row.qtzt == "1") {
          this.enableBtn.on = true;
          this.enableBtn.stop = false;
          this.enableBtn.update = true;
          this.enableBtn.del = true;
        }
      } else {
        this.enableBtn.update = true;
        this.enableBtn.del = true;
        this.enableBtn.on = true;
        this.enableBtn.stop = true;
      }
    }
  },
  created() {
    this.pageWidth = window.innerWidth - 200;
    _kits = this.$kits();
    _table = _kits.table(
      "QUERYDSRWLIST",
      () => {
        return Object.assign({}, this.filterData, this.pagination);
      },
      result => {
        this.isShowLoading = false;
        this.recordData = result.list;
        this.pagination.total = Number.parseInt(result.total);
      }
    );
    this.init();
  },
  mounted() {}
};
</script>
<style scoped>
</style>
